<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useEntityStore } from '@/modules/investing/stores/better-entity-store'
import EntityLayout from '@/modules/investing/components/entities/entity-layout.vue'
import { useSkeleton } from '@/modules/core/composables/useSkeleton'
import TheFileSystem from '../../components/TheFileSystem.vue'
import { useRoute } from 'vue-router'
import { useFilingStore } from '../../stores/filing-store'

const { entity_id, slug } = useRoute().params as { entity_id: string; slug: string }

const entityStore = useEntityStore()
const filingStore = useFilingStore()
const theFileSystem = ref(null)

const { skeleton, hideSkeleton, showSkeleton } = useSkeleton()

const entity = computed(() => entityStore.entity)
const rootFolder = computed(() =>
  filingStore.folders.find((folder) => folder.id === entity.value.filing_folder_root_id),
)

onMounted(async () => {
  showSkeleton()
  filingStore.resetStore()
  await entityStore.fetchEntity(entity_id, { slug })
  await filingStore.fetchFolder(entity.value.filing_folder_root_id)
  await theFileSystem.value?.fetchAll()
  hideSkeleton()
})
</script>

<template>
  <EntityLayout selectedTab="file_system">
    <div class="mx-auto">
      <TheFileSystem
        ref="theFileSystem"
        :skeleton="skeleton"
        :rootFolder="rootFolder"
        :shareholders="entityStore.listShareholders"
        :entity="entity"
      />
    </div>
  </EntityLayout>
</template>
